// import constants from './constants'
import { useContext } from 'react'
import StoreContext from '../providers/storesContext'

const assistedReleaseRemainingTime = () => {
  /**
   *  @todo The intention probably was to show the actual remaining time,
   *  not the general time interval.
   *  This was faster.
   */

  const { caseDetailStore } = useContext(StoreContext)

  let mins = 1 * caseDetailStore.minutesToAssistRelease
  let hours = Math.floor(mins / 60)
  mins = mins % 60
  const days = Math.floor(hours / 24)
  hours = hours % 24

  return [days > 0 && `${days} days`, hours > 0 && `${hours} hours`, mins > 0 && `${mins} minutes`]
    .filter(Boolean)
    .join(', ')
}

export default assistedReleaseRemainingTime
